module.exports = __webpack_public_path__ + "img/Arrow-right-deep-fjord-900.ee1611ff.svg";